import { Text } from '@/ui';
import { settingsHelperTextSx } from '@/ui/composites/settingsPageTypographySx';
import type { ElementType, ReactElement, ReactNode } from 'react';

type ProjectSettingsHelperTextProps = {
  children: ReactNode;
  component?: ElementType;
};

export const ProjectSettingsHelperText = ({
  children,
  component = 'p',
}: ProjectSettingsHelperTextProps): ReactElement => (
  <Text role="bodyMuted" component={component} sx={settingsHelperTextSx}>
    {children}
  </Text>
);
